<template>
<div class="solutionPage">
	<div class="solutionImageBox" ref="headerImageRef">
		<img class="solutionImage" src="@/assets/solutionIMG.png" />
		<div class="solutionTextBox">
			<div class="solutionTitle" style="margin-top: 3rem;">
				全场景解决方案，精准破解健康管理痛点<br />
                Full-Scenario Solutions to Wellness Management Pain Points
			</div>
			<div class="solutionText" style="margin-top: 3rem;">
				覆盖政府/企业、教育、公共健康三大场景，提供全流程服务<br />
                Covering government/enterprise, education, and public health—delivering end-to-end services
			</div>
		</div>
	</div>
	<div style="height: 11.7rem; width: 1px;" />

	<div class="pulseSolutionBox">
		<div class="boxCNTitle">
			解决方案
		</div>
		<div style="width: 1px; height: 1rem" />

		<div class="boxENTitle">
			PULSE ECOSYSTEM VISUALIZATION
		</div>
		<div style="height: 6.7rem; width: 1px;" />

        <transition name="solution-fade" mode="out-in">
            <div class="pulseSolutionBriefingLine" v-if="selectedIndex == 0" key="briefing-0">
                <div class="pulseSolutionBriefingItem">
                    <div style="height: 3.3rem; width: 1px;" />
                    <div class="pulseSolutionBriefingIndex" style="background-color: rgba(120, 223, 162, 0.1); color: #78DFA2">
                        01
                    </div>

                    <div style="height: 0.8rem; width: 1px;" />
                    <div class="pulseSolutionBriefingTitle">
                        企业 EAP 服务
                    </div>

                    <div style="height: 0.8rem; width: 1px;" />
                    <div class="pulseSolutionBriefingDescription">
                        心理体检、分级预警、线上咨询、团体辅导、专家讲座（职场压力、亲子教育等）
                    </div>

                    <div style="flex: 1; width: 1px;" />
                </div>
                <div class="pulseSolutionBriefingItem">
                    <div style="height: 3.3rem; width: 1px;" />
                    <div class="pulseSolutionBriefingIndex" style="background-color: rgba(125, 207, 226, 0.1); color: #7DCFE2">
                        02
                    </div>

                    <div style="height: 0.8rem; width: 1px;" />
                    <div class="pulseSolutionBriefingTitle">
                        政企定制服务
                    </div>

                    <div style="height: 0.8rem; width: 1px;" />
                    <div class="pulseSolutionBriefingDescription">
                        职工干部心理关爱、危机干预流程搭建、组织心理健康画像分析
                    </div>

                    <div style="flex: 1; width: 1px;" />
                </div>
                <div class="pulseSolutionBriefingItem">
                    <div style="height: 3.3rem; width: 1px;" />
                    <div class="pulseSolutionBriefingIndex" style="background-color: rgba(219, 174, 255, 0.1); color: #DBAEFF">
                        03
                    </div>

                    <div style="height: 0.8rem; width: 1px;" />
                    <div class="pulseSolutionBriefingTitle">
                        数据管理支持
                    </div>

                    <div style="height: 0.8rem; width: 1px;" />
                    <div class="pulseSolutionBriefingDescription">
                        实时数据看板、干预效果追踪、年度健康报告输出
                    </div>

                    <div style="flex: 1; width: 1px;" />
                </div>
                <div class="pulseSolutionBriefingItem">
                    <div style="height: 3.3rem; width: 1px;" />
                    <div class="pulseSolutionBriefingIndex" style="background-color: rgba(255, 186, 118, 0.1); color: #FFBA76">
                        04
                    </div>

                    <div style="height: 0.8rem; width: 1px;" />
                    <div class="pulseSolutionBriefingTitle">
                        适配场景
                    </div>

                    <div style="height: 0.8rem; width: 1px;" />
                    <div class="pulseSolutionBriefingDescription">
                        企业日常员工关怀、政府单位职工关爱、大型组织团建活动、危机事件应急处置
                    </div>

                    <div style="flex: 1; width: 1px;" />
                </div>
            </div>
            <div class="pulseSolutionBriefingLine" v-if="selectedIndex == 1" key="briefing-1">
                <div class="pulseSolutionBriefingItem">
                    <div style="height: 3.3rem; width: 1px;" />
                    <div class="pulseSolutionBriefingIndex" style="background-color: rgba(120, 223, 162, 0.1); color: #78DFA2">
                        01
                    </div>

                    <div style="height: 0.8rem; width: 1px;" />
                    <div class="pulseSolutionBriefingTitle">
                        学生心理健康管理
                    </div>

                    <div style="height: 0.8rem; width: 1px;" />
                    <div class="pulseSolutionBriefingDescription">
                        专业量表测评、动态监测、五级预警、“一生一档” 管理
                    </div>

                    <div style="flex: 1; width: 1px;" />
                </div>
                <div class="pulseSolutionBriefingItem">
                    <div style="height: 3.3rem; width: 1px;" />
                    <div class="pulseSolutionBriefingIndex" style="background-color: rgba(125, 207, 226, 0.1); color: #7DCFE2">
                        02
                    </div>

                    <div style="height: 0.8rem; width: 1px;" />
                    <div class="pulseSolutionBriefingTitle">
                        教师赋能
                    </div>

                    <div style="height: 0.8rem; width: 1px;" />
                    <div class="pulseSolutionBriefingDescription">
                        心理技能培训、AI 教案助手、教学资源库（课件、案例）
                    </div>

                    <div style="flex: 1; width: 1px;" />
                </div>
                <div class="pulseSolutionBriefingItem">
                    <div style="height: 3.3rem; width: 1px;" />
                    <div class="pulseSolutionBriefingIndex" style="background-color: rgba(219, 174, 255, 0.1); color: #DBAEFF">
                        03
                    </div>

                    <div style="height: 0.8rem; width: 1px;" />
                    <div class="pulseSolutionBriefingTitle">
                        家校社协同
                    </div>

                    <div style="height: 0.8rem; width: 1px;" />
                    <div class="pulseSolutionBriefingDescription">
                        家长课堂、亲子沟通训练、医疗机构绿色通道对接
                    </div>

                    <div style="flex: 1; width: 1px;" />
                </div>
                <div class="pulseSolutionBriefingItem">
                    <div style="height: 3.3rem; width: 1px;" />
                    <div class="pulseSolutionBriefingIndex" style="background-color: rgba(255, 186, 118, 0.1); color: #FFBA76">
                        04
                    </div>

                    <div style="height: 0.8rem; width: 1px;" />
                    <div class="pulseSolutionBriefingTitle">
                        适配场景
                    </div>

                    <div style="height: 0.8rem; width: 1px;" />
                    <div class="pulseSolutionBriefingDescription">
                        区域教育局统筹管理、中小学日常筛查干预、重点学生跟踪、心理健康示范校建设
                    </div>

                    <div style="flex: 1; width: 1px;" />
                </div>
            </div>
            <div class="pulseSolutionBriefingLine" v-if="selectedIndex == 2" key="briefing-2">
                <div class="pulseSolutionBriefingItem">
                    <div style="height: 3.3rem; width: 1px;" />
                    <div class="pulseSolutionBriefingIndex" style="background-color: rgba(120, 223, 162, 0.1); color: #78DFA2">
                        01
                    </div>

                    <div style="height: 0.8rem; width: 1px;" />
                    <div class="pulseSolutionBriefingTitle">
                        慢病康复
                    </div>

                    <div style="height: 0.8rem; width: 1px;" />
                    <div class="pulseSolutionBriefingDescription">
                        心理 + 运动 + 营养一体化数字处方、症状监测与干预
                    </div>

                    <div style="flex: 1; width: 1px;" />
                </div>
                <div class="pulseSolutionBriefingItem">
                    <div style="height: 3.3rem; width: 1px;" />
                    <div class="pulseSolutionBriefingIndex" style="background-color: rgba(125, 207, 226, 0.1); color: #7DCFE2">
                        02
                    </div>

                    <div style="height: 0.8rem; width: 1px;" />
                    <div class="pulseSolutionBriefingTitle">
                        认知健康
                    </div>

                    <div style="height: 0.8rem; width: 1px;" />
                    <div class="pulseSolutionBriefingDescription">
                        阿尔兹海默症线上筛查、脑健康训练、就医衔接
                    </div>

                    <div style="flex: 1; width: 1px;" />
                </div>
                <div class="pulseSolutionBriefingItem">
                    <div style="height: 3.3rem; width: 1px;" />
                    <div class="pulseSolutionBriefingIndex" style="background-color: rgba(219, 174, 255, 0.1); color: #DBAEFF">
                        03
                    </div>

                    <div style="height: 0.8rem; width: 1px;" />
                    <div class="pulseSolutionBriefingTitle">
                        公共筛查
                    </div>

                    <div style="height: 0.8rem; width: 1px;" />
                    <div class="pulseSolutionBriefingDescription">
                        区域心理健康定向调研、危机人群识别、资源优化配置
                    </div>

                    <div style="flex: 1; width: 1px;" />
                </div>
                <div class="pulseSolutionBriefingItem">
                    <div style="height: 3.3rem; width: 1px;" />
                    <div class="pulseSolutionBriefingIndex" style="background-color: rgba(255, 186, 118, 0.1); color: #FFBA76">
                        04
                    </div>

                    <div style="height: 0.8rem; width: 1px;" />
                    <div class="pulseSolutionBriefingTitle">
                        适配场景
                    </div>

                    <div style="height: 0.8rem; width: 1px;" />
                    <div class="pulseSolutionBriefingDescription">
                        社区健康服务、医院慢病管理、老年康养机构、公共卫生项目
                    </div>

                    <div style="flex: 1; width: 1px;" />
                </div>
            </div>
        </transition>
        <div style="height: 2.4rem; width: 1px;" />

        <div class="pulseSolutionDetailLine">
            <transition name="solution-fade" mode="out-in">
                <img
                    class="pulseSolutionDetailPic"
                    :key="`solution-pic-${selectedIndex}`"
                    :src="require(`@/assets/solution${selectedIndex}.png`)"
                />
            </transition>
            <div style="width: 10.8rem; height: 1px;" />
            <div class="pulseSolutionDetailBox">
                <div class="pulseSolutionDetailBlock" @mouseenter="selectedIndex = 0">
                    <div class="pulseSolutionDetailHeaderIcon" :style="{'background-color': selectedIndex == 0 ? '#78DFA2' : ''}" />
                    <div class="pulseSolutionDetailHeader" :style="{'color': selectedIndex == 0 ? '#78DFA2' : ''}">
                        政府与企业解决方案
                    </div>
                    <div style="height: 1.2rem; width: 1px;" />
                    <div class="pulseSolutionDetailText">
                        核心痛点：员工心理压力大、危机事件应对不足、组织健康数据缺失、政企心理服务体系不完善
                    </div>
                </div>
                <div class="pulseSolutionDetailSplitter" />

                <div class="pulseSolutionDetailBlock" @mouseenter="selectedIndex = 1">
                    <div class="pulseSolutionDetailHeaderIcon" :style="{'background-color': selectedIndex == 1 ? '#78DFA2' : ''}" />
                    <div class="pulseSolutionDetailHeader" :style="{'color': selectedIndex == 1 ? '#78DFA2' : ''}">
                        教育解决方案
                    </div>
                    <div style="height: 1.2rem; width: 1px;" />
                    <div class="pulseSolutionDetailText">
                        核心痛点：学校心理师资不足、学生心理数据碎片化、预警滞后、家校社协同不畅、政策落地困难
                    </div>
                </div>
                <div class="pulseSolutionDetailSplitter" />
                <div class="pulseSolutionDetailBlock" @mouseenter="selectedIndex = 2">
                    <div class="pulseSolutionDetailHeaderIcon" :style="{'background-color': selectedIndex == 2 ? '#78DFA2' : ''}" />
                    <div class="pulseSolutionDetailHeader" :style="{'color': selectedIndex == 2 ? '#78DFA2' : ''}">
                        公共健康与医疗解决方案
                    </div>
                    <div style="height: 1.2rem; width: 1px;" />
                    <div class="pulseSolutionDetailText">
                        核心痛点：慢病患者心理康复缺口、老年认知健康管理不足、公共心理筛查效率低
                    </div>
                </div>
            </div>
        </div>
        <div style="height: 7rem; width: 1px;" />
	</div>

</div>
</template>

<script>
export default {
	data() {
		return {
            selectedIndex: 0,
		}
	},
	methods: {
		emitHeroHeight() {
			const height = this.$refs.headerImageRef ? this.$refs.headerImageRef.offsetHeight : 20;
			this.$emit("headerImageRefHeight", height);
		}
	},
	created() {
	},
	mounted() {
		this.emitHeroHeight();
		window.addEventListener("resize", this.emitHeroHeight);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.emitHeroHeight);
	},
	watch: {
	},
}
</script>

<style lang="scss" scoped>
.solutionPage {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

	.solutionImageBox {
		width: 100%;
		height: 51.4rem;
		position: relative;
		background-color: #212121;

		.solutionImage {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0px;
			left: 0px;
			object-fit: cover;
		}

		.solutionTextBox {
			position: absolute;
			width: 1200px;
			left: calc((100% - 1200px) / 2);
			top: 20%;
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: center;

			.solutionTitle {
				font-size: 5.3rem;
				text-align: left;
				color: #FFFFFF;
			}
			.solutionText {
				font-size: 1.5rem;
				line-height: 2.5rem;
				text-align: left;
				color: #FFFFFF;
			}
		}
	}

	.pulseSolutionBox {
        box-sizing: border-box;
        width: 100%;
        padding-left: 10rem;
        padding-right: 10rem;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .pulseSolutionBriefingLine {
            width: 100rem;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }

        .pulseSolutionBriefingItem {
            width: 23.5rem;
            height: 22.3rem;
            box-shadow: 0rem 0.3rem 3.3rem 0rem rgba(51, 51, 51, 0.05);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            transition: transform 0.35s ease, box-shadow 0.35s ease, opacity 0.35s ease;

            .pulseSolutionBriefingIndex {
                width: 5rem;
                height: 5rem;
                border-radius: 100%;
                font-size: 2.7rem;
                line-height: 5rem;
                text-align: center;
                font-weight: bold;
                transition: background-color 0.35s ease, color 0.35s ease;
            }

            .pulseSolutionBriefingTitle {
                width: 16.8rem;
                font-size: 1.5rem;
                line-height: 2.4rem;
                color: #333333;
                text-align: center;
                transition: color 0.35s ease, opacity 0.35s ease;
            }

            .pulseSolutionBriefingDescription {
                width: 16.8rem;
                font-size: 1.3rem;
                line-height: 2.1rem;
                color: rgba(51, 51, 51, 0.7);
                text-align: center;
                transition: color 0.35s ease, opacity 0.35s ease;
            }
        }

        .pulseSolutionDetailLine {
            width: 100rem;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;

            .pulseSolutionDetailPic {
                flex: 1 1 0;
                min-width: 0;
                height: auto;
                min-height: 45rem;
                object-fit: contain;
            }
            .pulseSolutionDetailBox {
                flex: 1 1 0;
                min-width: 0;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: center;
                cursor: pointer;

                .pulseSolutionDetailBlock {
                    width: 100%;
                    position: relative;
                    transition: opacity 0.35s ease, transform 0.35s ease;

                    .pulseSolutionDetailHeaderIcon {
                        position: relative;
                        width: 0.8rem;
                        height: 0.8rem;
                        top: 1.7rem;
                        left: -2rem;
                        background-color: #333333;
                        transition: background-color 0.35s ease, transform 0.35s ease;
                    }
                    .pulseSolutionDetailHeader {
                        color: #333333;
                        font-size: 2rem;
                        line-height: 3rem;
                        text-align: left;
                        transition: color 0.35s ease;
                    }
                    .pulseSolutionDetailText {
                        color: rgba(51, 51, 51, 0.7);
                        font-size: 1.3rem;
                        line-height: 2.4rem;
                        text-align: left;
                        transition: color 0.35s ease, opacity 0.35s ease;
                    }
                }
                // .pulseSolutionDetailBlock:hover {
                //     transform: translateX(0.4rem);
                // }

                .pulseSolutionDetailSplitter {
                    width: 100%;
                    height: 1px;
                    background-color: rgba(51, 51, 51, 0.1);
                    margin-top: 2.3rem;
                    margin-bottom: 1.7rem;
                    transition: opacity 0.35s ease;
                }
            }
        }
    }

	
}

/* 通用淡入淡出 + 轻微位移 */
.solution-fade-enter-active,
.solution-fade-leave-active {
    transition: opacity 0.2s ease, transform 0.2s ease;
}

.solution-fade-enter,
.solution-fade-leave-to {
    opacity: 0;
}

.boxCNTitle{
	font-size: 4rem;
	line-height: 4.8rem;
	color: #1D1D1F;
	font-weight: 600;
}
.boxENTitle{
	font-size: 1.7rem;
	line-height: 1.8rem;
	color: #666666;
}
</style>